import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import ManageFormsPage from './ManageFormsPage.js';

export default WithGASetup(ManageFormsPage, AuthContext);
